import { render, staticRenderFns } from "./FailureAnnouncements.vue?vue&type=template&id=7f66732a&scoped=true&"
import script from "./FailureAnnouncements.vue?vue&type=script&lang=js&"
export * from "./FailureAnnouncements.vue?vue&type=script&lang=js&"
import style0 from "./FailureAnnouncements.vue?vue&type=style&index=0&id=7f66732a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f66732a",
  null
  
)

export default component.exports